import {
  CLIENT_TYPE,
  CLIENT_TYPE_HEADER,
} from '@upstart/harmony/lib/constants';
import { GlobalConfigurationId } from '@upstart/harmony/lib/legos/constants/globalConfigurations';
import { AxiosResponse } from 'axios';
import {
  LendingSupportedStatesData,
  LendingSupportedFNITypesData,
} from '@upstart/harmony/lib/legos/globalConfigurationTypes';
import { BackendService } from './BackendService';

const ONLINE_HEADERS = {
  [CLIENT_TYPE_HEADER]: CLIENT_TYPE.ONLINE,
};

interface GlobalConfigurationsGet {
  [GlobalConfigurationId.LendingSupportedFNITypes]: LendingSupportedFNITypesData;
  [GlobalConfigurationId.LendingSupportedStates]: LendingSupportedStatesData;
}

export class GlobalConfigurationsService {
  static async get(): Promise<AxiosResponse<GlobalConfigurationsGet>> {
    const ids = [
      GlobalConfigurationId.LendingSupportedFNITypes,
      GlobalConfigurationId.LendingSupportedStates,
    ];
    return BackendService.get<any>(`/globalConfigurations?ids=${ids}`, {
      headers: ONLINE_HEADERS,
    });
  }
}
